import { render, staticRenderFns } from "./CheckoutForm.vue?vue&type=template&id=35e2c83d"
import script from "./CheckoutForm.vue?vue&type=script&lang=js"
export * from "./CheckoutForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CheckoutForm.vue"
export default component.exports